import * as yup from 'yup'

export const passwordRules = [
  {
    id: 'min',
    text: 'Ingresá 8 caracteres como mínimo',
    schema: yup.string().min(8, 'Ingresá 8 caracteres como mínimo')
  },
  {
    id: 'uppercase',
    text: 'Utilizá al menos una mayúscula',
    schema: yup.string().matches(/[A-Z]/, 'Utilizá al menos una mayúscula')
  },
  {
    id: 'special',
    text: 'Usá un símbolo o caracter especial',
    schema: yup.string().matches(/[!@#$%^&*(),.?":{}|<>]/, 'Usá un símbolo o caracter especial')
  },
  {
    id: 'number',
    text: 'Ingresá al menos un número',
    schema: yup.string().matches(/\d/, 'Ingresá al menos un número')
  }
]

export const nuevaContraseñaSchema = yup.object().shape({
  password: passwordRules.reduce((schema, rule) => schema.concat(rule.schema), yup.string().required('La contraseña es requerida')),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Las contraseñas no coinciden')
    .required('Confirmá tu contraseña')
})
